skrilla.controller('updatedBetStopModalCtrl', function ($scope, modalService, searchService, cacheService) {
    $scope.market = cacheService.getObject("bettingMarketDetails")?.market;
    $scope.event = cacheService.getObject("event");
    $scope.nextBetStop = null;
    $scope.betStopOn = "MARKET"
    $scope.newStatus = 'SUSPENDED'
    $scope.control = true
    $scope.stopType = 'NOW'

    $scope.update = function(){
        const marketIds = $scope.betStopOn === "EVENT" ? [] : [$scope.market.id]
        const request = {
            nextBetStop: $scope.stopType === 'SCHEDULED' ? $scope.nextBetStop : null,
            marketIds,
            status: $scope.newStatus,
            control: $scope.control ? 'ACTIVE' : null,
            reason: $scope.reason,
        };
        searchService.put("betting/events/" + $scope.event.eventId + "/nextBetStop",  request, "Bet stop set for event markets").then(function(response){
            modalService.dismissAll();
        });
    }
});
